export const TYPE_REPORT = {
  BRAIN_FUNCTION_MAPPING: 1,
  FIVE_INDICATORS: 2,
  BRAIN_FUNCTION_CONNECTIVITY: 3,
}

export const REANALYSIS_REPORT_TYPE = {
  BASIC: 1,
  FIVE_INDICATORS: 3,
  CONNECTIVITY: 4,
}

export const REANALYSIS_REPORT_OPTIONS = [
  {
    key: REANALYSIS_REPORT_TYPE.BASIC,
    label: 'IBrainFunctionMappingBasic',
  },
  {
    key: REANALYSIS_REPORT_TYPE.FIVE_INDICATORS,
    label: 'IBrainFunctionIndicators',
  },
  {
    key: REANALYSIS_REPORT_TYPE.CONNECTIVITY,
    label: 'IBrainFunctionConnectivity',
  },
]

export const EEG_SUMMARY_TABS = [
  {id: TYPE_REPORT.BRAIN_FUNCTION_MAPPING, label: 'IBrainFunctionMapping'},
  {id: TYPE_REPORT.FIVE_INDICATORS, label: 'IBrainFunctionIndicators'},
  {
    id: TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY,
    label: 'IBrainFunctionConnectivity',
  },
]

export const SUMMARY_REPORT_TYPE = 'reportService'
